// @ts-nocheck
import { get } from "@insite/client-framework/Services/ApiService";
import { PartModel, PartsListModel, SkuModel } from "@store/Framework/Types/ApiModels";

const partsUrl = "/api/v1/parts/";

export interface GetSkusParameter {
    id: string;
}
const encodeUndesiredCharacters = (barcodeOrModelOrSerialNumber: string) => {
    barcodeOrModelOrSerialNumber = encodeURIComponent(barcodeOrModelOrSerialNumber);
    return barcodeOrModelOrSerialNumber;
};

export function getSkuListByBarcodeOrModelOrSerialNumber(parameter: GetSkusParameter) {
    try {
        const barcodeOrModelOrSerialNumber = encodeUndesiredCharacters(parameter.id);
        return get<SkuModel[]>(`${partsUrl}getskulist/${barcodeOrModelOrSerialNumber}`);
    } catch (error) {
        global.console.error("Error fetching SKU list:", error);
        throw new Error("Failed to fetch SKU list. Please try again later.");
    }
}

export function getPartsListByModelNumber(parameter: string) {
    try {
        const modelNumber = encodeUndesiredCharacters(parameter);
        return get<PartsListModel>(`${partsUrl}model/${modelNumber}`);
    } catch (error) {
        global.console.error("Error fetching parts list:", error);
        throw new Error("Failed to fetch parts list. Please try again later.");
    }
}

export function getReplacementsList(productId: string, partNumber?: string) {
    try {
        const encodedProductId = encodeUndesiredCharacters(productId);
        const encodedPartNumber = partNumber
            ? encodeUndesiredCharacters(partNumber)
            : "00000000-0000-0000-0000-000000000000";
        return get<PartModel[]>(`${partsUrl}getsupersedehistory/${encodedProductId}/${encodedPartNumber}`);
    } catch (error) {
        global.console.error("Error fetching replacements list:", error);
        throw new Error("Failed to fetch replacements list. Please try again later.");
    }
}
